import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { ErrorMessage } from "formik";
import { RevenueInputProps } from "./revenue-input-props";
import "./revenue-input-component.scss";

const RevenueInputComponent: React.FC<RevenueInputProps> = ({
  fieldName,
  label = "Annual Revenue",
  placeholder = "Enter revenue...",
  optional = false,
  disabled,
  value,
  onChange,
  min,
  max,
  logo,
  isRequired = false,
  useFormikError=true
}) => {
  return (
    <Box className="revenue-input-component">
      {/* Label */}
      {label && <InputLabel required={optional} htmlFor={fieldName}>
        {label}
      </InputLabel>}

      {/* Input Field */}
      <FormControl className={`input-container ${isRequired ? "required" : ""}`}>
        <TextField
          name={fieldName}
          placeholder={placeholder}
          required={optional}
          disabled={disabled}
          id={fieldName}
          value={value}
          onChange={onChange}
          type="text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <span className="currency-symbol">$</span>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <img src={logo} alt="info" className="info-icon" />
              </InputAdornment>
            ),
          }}
          inputProps={{
            inputMode: "decimal",
          }}
        />
      </FormControl>

      {/* Error Message */}
      {useFormikError && fieldName && <ErrorMessage
        name={fieldName ?? ""}
        component="div"
        className="error-message"
      />}
    </Box>
  );
};

export default RevenueInputComponent;
